<template>
    <div>
        <div class="row indentation">
            <div class="col header text-left">
                <h3>
                    Die IMMOCOACH AG plante, realisierte seit ihrer Gründung
                    1999 innovative Bauprojekte für diese Unternehmen.
                </h3>
            </div>
            <div class="col jubilee-wrapper">
                <img
                    src="../assets/images/logo/jubilee_emblem_ic_2024.png"
                    class="jubilee"
                    alt="Jubiläumsemblem"
                    height="60"
                    align="right"
                />
            </div>
        </div>
        <hr />
        <div class="row gallery-padding">
            <div
                class="col-lg-4 col-md-6 col-12 gallery-item"
                v-for="(item, index) in config.references"
                :key="index + 100"
            >
                <span class="helper"></span>
                <img
                    :src="getImageURL(item.image)"
                    class="img-fluid ref-image text-center pagination-centered"
                    v-bind:alt="item.companyName"
                />
            </div>
        </div>
        <immo-footer />
    </div>
</template>

<script>
import ImmoFooter from './Footer.vue'

export default {
    name: 'references',
    components: {
        ImmoFooter
    },
    props: {
        config: ''
    },
    methods: {
        getImageURL(imageName) {
            return require('../assets/images/logos/' + imageName)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/main.scss';

.gallery-padding {
    padding-left: 15px;
    padding-right: 15px;
}

.gallery-item {
    white-space: nowrap; /* this is required unless the helper span is put closely near the img */
    text-align: center;
}

.indentation {
    padding-left: $main-indent;
    padding-right: $main-indent;
}

.helper {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
}

.ref-image {
    vertical-align: middle;
    padding: 50px;
}

.header {
    font-family: 'miso-light', Arial, sans-serif;
    padding-top: 110px;
    padding-bottom: 80px;
    padding-left: 1rem;
}

.jubilee-wrapper {
    padding-top: 95px;
    padding-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/ReferencesComponent.vue